export default "__VITE_ASSET__BDk6ARih__"